import type { Action } from 'src/types';

interface State {
  isLoading: boolean;
  profileLoadError: boolean;
  profileAuthError: boolean;
  isProfileSuggestionsExperiment: boolean;
}

export const initialState: State = {
  isLoading: true,
  profileLoadError: false,
  profileAuthError: false,
  isProfileSuggestionsExperiment: false, // TODO: Remove this line after the experiment is over
};

export enum ProfileActions {
  PROFILE_LOADING = 'PROFILE_LOADING',
  PROFILE_FAILURE = 'PROFILE_FAILURE',
  PROFILE_NOT_AUTHENTICATED = 'PROFILE_NOT_AUTHENTICATED',
  PROFILE_RENDERED = 'PROFILE_RENDERED',
  PROFILE_LOADED = 'PROFILE_LOADED',
  SET_PROFILE_SUGGESTIONS_EXPERIMENT = 'SET_PROFILE_SUGGESTIONS_EXPERIMENT', // TODO: Remove this line after the experiment is over
}

export type ProfileAction =
  | (Action<ProfileActions.PROFILE_FAILURE> & {
      payload: Error;
    })
  | Action<ProfileActions.PROFILE_LOADING>
  | (Action<ProfileActions.PROFILE_NOT_AUTHENTICATED> & {
      payload: Error;
    })
  | Action<ProfileActions.PROFILE_RENDERED>
  | Action<ProfileActions.PROFILE_LOADED>
  | (Action<ProfileActions.SET_PROFILE_SUGGESTIONS_EXPERIMENT> & {
      payload: boolean;
    }); // TODO: Remove this line after the experiment is over

export const profileReducer = (
  state: State = initialState,
  action: ProfileAction,
) => {
  switch (action.type) {
    case ProfileActions.PROFILE_FAILURE: {
      return {
        ...state,
        isLoading: true,
        profileLoadError: true,
      };
    }

    case ProfileActions.PROFILE_NOT_AUTHENTICATED: {
      return {
        ...state,
        isLoading: true,
        profileAuthError: true,
      };
    }

    case ProfileActions.PROFILE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case ProfileActions.PROFILE_LOADED: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case ProfileActions.SET_PROFILE_SUGGESTIONS_EXPERIMENT: {
      return {
        ...state,
        isProfileSuggestionsExperiment: action.payload,
      };
    }
    default:
      return state;
  }
};
